import React from 'react'
import {
  Container,
  Header,
  Message,
  Form,
  TextArea,
  Icon,
  Label,
} from 'semantic-ui-react'
import queryString from 'query-string'
import ImportSelectionPane from './ImportSelectionPane.js'

class ImportSelectionViaPaste extends React.Component {
  // props: match, mode, selections, onImport
  state = {
    text: '',
    selection: undefined,
    error: undefined,
  }
  parseToJson = (text) => {
    let jsonString;
    try {
      const url = new URL(text);
      const query = url.search;
      console.log("query:", query);
      const queryValues = queryString.parse(query)
      console.log("queryValues:", queryValues);
      jsonString = decodeURIComponent(queryValues.json);
    } catch (ex) {
      jsonString = text;
    }
    console.log("decodedJsonString:", jsonString);
    const selection = JSON.parse(jsonString);
    console.log("selection:", selection);
    return selection;
  }
  handleOnChange = (e, {value})=>{
    console.log("ImportSelectionViaPaste::handleOnChange()", e, value);
    let error;
    let selection;
    try {
      selection = this.parseToJson(value);
      error = undefined;
    } catch (ex) {
      selection = undefined;
      error = ex.message;
    }
    console.log(error);
    this.setState({
      text: value,
      selection: selection,
      error: error
    });
  }
  render() {
    return (
      <Container text style={{ marginTop: '7em', padding: '10px', background: 'white #fef0e7' }}>
        <Header as='h1' style={{color: '#f2711c'}}>
          Import Selection
        </Header>
        <Message info icon>
          <Icon name='info circle'/>
          <Message.Content>
            <Message.Header>What to import?</Message.Header>
            <p>
              If someone shared a selection with you,
              in the form of a URL or a JSON string,
              you can paste it below to import it.
            </p>
          </Message.Content>
        </Message>

        <Header as='h2'>Paste URL or JSON</Header>
        <p>
          Usually if someone shares a selection in the form of a URL,
          you can just click on the URL or paste the URL into your browser's address bar
          to import it directly.
          However, the URL may be too long for the browser or for the server,
          and you might get an error.
          In that case, you can paste the URL, or the JSON string,
          here to import it:
        </p>
        <Form>
          <Form.Field
            error={!!this.state.error}
          >
            <TextArea
              name='url'
              label='URL'
              placeholder='Paste URL or JSON here'
              value={this.state.text}
              onChange={this.handleOnChange}
            />
          </Form.Field>
          {
            this.state.error?
              <Label basic color='red'>
                {this.state.error}
              </Label>
            :<span></span>
          }
        </Form>
        {
          this.state.selection
          ?
          <ImportSelectionPane
            selection={this.state.selection}
            selections={this.props.selections}
            onImport={this.props.onImport}
          />
          :
          null
        }
      </Container>
    );
  }
}

export default ImportSelectionViaPaste